import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { tr } from "date-fns/esm/locale";
import { getLocalLanguage } from "../../common";

export default function EndDate(props) {
    const { t } = useTranslation("translation");
    return (
        <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={getLocalLanguage()}>
            <DatePicker
                id="bl_table_DatePicker _13"
                renderInput={(_props) => <TextField {..._props} size="small" />}
                inputFormat="dd.MM.yyyy"
                value={props.endDate}
                maxDate={props.maxDate ? props.maxDate : null}
                minDate={props.minDate ? props.minDate : null}
                label={props.label ? props.label : t("EndDate")}
                onChange={props.HandleEndDate}
                ampm={false}
                margin="normal"
            />
        </LocalizationProvider>
    );
}
